import script from "./NavApp.vue?vue&type=script&setup=true&lang=js"
export * from "./NavApp.vue?vue&type=script&setup=true&lang=js"

import "./NavApp.vue?vue&type=style&index=0&id=658395b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-658395b4"]])

export default __exports__